import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

export const Scopri = (props) => {

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="pages" >
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>


      <div className='logo'>
        <Link to="/"><ContentLanding stringToRet="logo" /></Link>
      </div>

      <div className="content scopri">

        <h1>M4RT3! L’escape room online tra scienza e fantascienza per scoprire i misteri di Marte</h1>

        <div className="icons">
          <div className="icon">
            <CommonSvgContent stringToRet="time" />
            <p>Gioca quando vuoi</p>
          </div>

          <div className="icon">
            <CommonSvgContent stringToRet="device" />
            <p>Collegati da casa<br />con pc o tablet</p>
          </div>

          <div className="icon">
            <CommonSvgContent stringToRet="gruppo" />
            <p>Con amici,<br />famiglia o colleghi</p>
          </div>
        </div>

        <p>M4RT3! è una escape room online <strong>narrativa</strong> e <strong>investigativa</strong><br />
        dedicata al pianeta rosso <strong>Marte</strong> e all’<strong>astronomia</strong>.</p>

        <h2><strong>Cioè?</strong></h2>
        <p>È un gioco <strong>collaborativo</strong> per due o più amici in presenza o connessi
        online in videochiamata con l’obiettivo di venire a capo di un mistero
        risolvendo <strong>enigmi</strong> basati su <strong>documenti di archivio</strong> e <strong>informazioni reali</strong>.</p>

        <h2><strong>Come funziona?</strong></h2>
        <p>Si accede tramite pc e si naviga un sito web. Un avvincente
        racconto vi trasporterà in una dimensione al confine tra fiction, realtà
        storica e attualità, durante il quale sarete chiamati in prima persona a
        interagire con documenti, visitare luoghi virtuali misteriosi, fare ricerche
        sul web, svolgendo indagini e guidati da <strong>spirito di osservazione</strong> e <strong>deduzione logica</strong>.<br />
        Per progredire nel racconto, dovrete risolvere <strong>dieci enigmi</strong>, che verranno
        sbloccati man mano inserendo le password corrette. Avrete <strong>90 minuti</strong> di tempo
        per giungere alla soluzione finale del gioco ed entrare nell’olimpo dei migliori
        indagatori planetari!</p>

        <img className="elements" src={require('../assets/images/elementi.png')} alt="" />

        <Link className="btn btn-danger backTo" to="/">Torna</Link>

      </div>


    </div>
  )
}
